/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Billing_MonthlyInputs */

const en_pricing_billing_monthly = /** @type {(inputs: Pricing_Billing_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly`)
};

const es_pricing_billing_monthly = /** @type {(inputs: Pricing_Billing_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensual`)
};

const fr_pricing_billing_monthly = /** @type {(inputs: Pricing_Billing_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensuel`)
};

const de_pricing_billing_monthly = /** @type {(inputs: Pricing_Billing_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatlich`)
};

const ja_pricing_billing_monthly = /** @type {(inputs: Pricing_Billing_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月払い`)
};

const zh_pricing_billing_monthly = /** @type {(inputs: Pricing_Billing_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月付`)
};

const ar_pricing_billing_monthly = /** @type {(inputs: Pricing_Billing_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شهرياً`)
};

const id_pricing_billing_monthly = /** @type {(inputs: Pricing_Billing_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bulanan`)
};

const it_pricing_billing_monthly = /** @type {(inputs: Pricing_Billing_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensile`)
};

const ru_pricing_billing_monthly = /** @type {(inputs: Pricing_Billing_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`За месяц`)
};

const pt_pricing_billing_monthly = /** @type {(inputs: Pricing_Billing_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensal`)
};

const ko_pricing_billing_monthly = /** @type {(inputs: Pricing_Billing_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`월간`)
};

/**
* | output |
* | --- |
* | "Monthly" |
*
* @param {Pricing_Billing_MonthlyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_billing_monthly = /** @type {((inputs?: Pricing_Billing_MonthlyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Billing_MonthlyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_billing_monthly(inputs)
	if (locale === "es") return es_pricing_billing_monthly(inputs)
	if (locale === "fr") return fr_pricing_billing_monthly(inputs)
	if (locale === "de") return de_pricing_billing_monthly(inputs)
	if (locale === "ja") return ja_pricing_billing_monthly(inputs)
	if (locale === "zh") return zh_pricing_billing_monthly(inputs)
	if (locale === "ar") return ar_pricing_billing_monthly(inputs)
	if (locale === "id") return id_pricing_billing_monthly(inputs)
	if (locale === "it") return it_pricing_billing_monthly(inputs)
	if (locale === "ru") return ru_pricing_billing_monthly(inputs)
	if (locale === "pt") return pt_pricing_billing_monthly(inputs)
	return ko_pricing_billing_monthly(inputs)
});